/* eslint-disable */
const genNodeType = (editor, data) => {
    switch (data.name) {
        case 'simple_message':
          editor.addNode(data.x, data.y, data.name, {
            comparator: '',
            text: 'Seja bem vindo, como podemos te ajudar?',
            key: '',
            action_id: '',
            back_node_id: '',
            back_id: '',
            back_name: '',
            first: false,
            action_name: 'SendSimpleMessage',
            type_send: 'TEXT',
            file_send: { type: '', mime_type: '', url: '', file_size: '' },
            has_file: false
          }, 1, 1, {
            label: 'Mensagem simples',
            icon: 'message'
          }, null, {}, {}, false);
          break;
        case 'flow_end':
          editor.addNode(data.x, data.y, data.name,
            {
              comparator: '',
              key: '',
              action_id: '',
              back_node_id: '',
              back_id: '',
              back_name: '',
              first: false,
              action_name: 'FlowEnd'
            }, 1, 0, {
            background: 'rgb(224, 215, 251)',
            label: 'Finalizar fluxo',
            icon: 'check',
          }, null, {}, {}, false);
          break;
        case 'template_whatsapp':
          editor.addNode(data.x, data.y, data.name, {
            comparator: '', text: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, template: {
              type: 'bottons',
              name: '',
            }, action_name: 'SendTemplateWhatsApp'
          }, 1, 1, {
            background: 'rgb(118 255 219)',
            label: 'Template',
            icon: 'palette',
          }, null, {}, {}, false);
          break;
        case 'send_file':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', action_id: '', wait_finish: true, back_node_id: '', back_id: '', back_name: '', mime_type: '', type: 'image', url: '', first: false, action_name: 'SendFileFlow' }, 1, 1, {
            background: '#ffbf00a8',
            label: 'Enviar arquivo',
            icon: 'upload_file',
          }, null, {}, {}, false);
          break;
        case 'next_additional':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'ReturnFlow' }, 1, 1, {
            background: '#afd8ff',
            label: 'Retornar flow',
            icon: 'redo',
          }, null, {}, {}, false);
          break;
        case 'response_expecter':
          editor.addNode(data.x, data.y, data.name, { comparator: '', variable_name: 'primeiro_nome', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'ResponseExpecter' }, 1, 1, {
            background: 'rgb(157, 239, 225)',
            label: 'Solicitar Dados',
            icon: 'data_exploration',
          }, null, {}, {}, false);
          break;
        case 'set_tabulation':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', action_id: '', wait_finish: true, auth: '', end_point: '', method: 'POST', parameters_body: [], parameters_path: [], parameters_header: [], back_node_id: '', failed_class_name: '', failed_action_node_id: '', failed_action_id: '', back_id: '', back_name: '', first: false, tabulation: '', action_name: 'SetTabulationFlow' }, 1, 1, {
            label: 'Tabulação',
            icon: 'tab'
          }, null, {}, {}, false);
          break;
        case 'send_location':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', id: '', wait_finish: true, back_node_id: '', back_id: '', back_name: '', first: false, name: '', address: '', latitude: '', longitude: '', action_name: 'SendLocationWhatsapp' }, 1, 1, {
            label: 'Localização',
            icon: 'location_on'
          }, null, {}, {}, false);
          break;
        case 'solved':
          editor.addNode(data.x, data.y, data.name, {  solved: true, identification_account: '', comparator: '', key: '', action_id: '', wait_finish: true, back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'SolvedFlow' }, 1, 1, {
            label: 'Marcar como resolvido',
            icon: 'check',
            color: '#fff',
            background: '#1fe080',
          }, null, {}, {}, false);
          break;
        case 'set_department':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', action_id: '', wait_finish: true, department: '', back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'SetDepartmentFlow' }, 1, 1, {
            label: 'Departamento',
            icon: 'support_agent',
            background: '#32a852',
            color: '#fff',
          }, null, {}, {}, false);
          break;
        case 'branch':
          editor.addNode(data.x, data.y, data.name, { comparator: '', key: '', attribute: 'primeiro_nome', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'BranchFlow', otherwise: '', otherwise_action_name: '' }, 1, 2, {
            background: 'rgb(253, 240, 208)',
            label: 'Condição',
            icon: 'flaky',
            outText: {
              1: '  Se',
              2: '  Ou'
            },
            outStyle: {
              1: '#e8d035',
              2: '#cf5915'
            },
          }, null, {}, {}, false);
          break;
        case 'add_variable':
          editor.addNode(data.x, data.y, data.name, { value: '', name: '', calc: false, comparator: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'AddVariableFlow' }, 1, 1, {
            label: 'Variável',
            icon: 'database'
          }, null, {}, {}, false);
          break;
        case 'contact_update':
          editor.addNode(data.x, data.y, data.name, { value: '', field: '', comparator: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'ContactUpdateFlow' }, 1, 1, {
            label: 'Atualizar Contato',
            icon: 'person'
          }, null, {}, {}, false);
          break;
        case 'consumir_api':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', action_id: '', wait_finish: true, auth: '', end_point: '', method: 'POST', parameters_body: [], parameters_path: [], parameters_header: [], back_node_id: '', failed_class_name: '', failed_action_node_id: '', failed_action_id: '', back_id: '', back_name: '', first: false, type_auth: 'Basic', type_body: 'raw', action_name: 'ConsumerApi' }, 1, 2, {
            label: 'API',
            icon: 'cloud_upload'
          }, null, {}, {}, false);
          break;
        case 'interactive_whatsapp':
          editor.addNode(data.x, data.y, data.name, {
            comparator: '', text: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, template: {
              type: 'bottons',
              body: '',
              button_text: 'Clique aqui',
              footer: '',
              header: {
                filename: null,
                header_id: null,
                link: null,
                provider_name: null,
                text: null,
                type: 'TEXT',
              },
              buttons: [
                {
                  button_config_id: '',
                  button_id: 1,
                  title: 'Texto Botão',
                },
              ],
              sections: [
                {
                  list_config_id: 1,
                  sectionList: [
                    {
                      description: 'Descrição',
                      list_id: 1,
                      section_list_id: '',
                      title: 'Título da lista',
                    },
                  ],
                  title: 'Título da sessão',
                },
              ],
            }, action_name: 'SendInteractiveWhatsApp'
          }, 1, 1, {
            label: 'Interação',
            icon: 'interactive_space'
          }, null, {}, {}, false);
          break;
        case 'loop_flow':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'LoopFlow', current_controller: true, send_action: '', send_action_id: '', class_name_controller: '', controller: '' }, 1, 2, {
            label: 'Loop',
            icon: 'all_inclusive',
            outText: {
              1: 'Ação',
              2: 'Saída'
            },
          }, null, {}, {}, false);
          break;
        case 'catalog_whatsapp':
          editor.addNode(data.x, data.y, data.name, {
            comparator: '', text: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false, catalog: {
              type: 'menu',
              body: '',
              catalog_id: '',
              footer: '',
              text_header: '',
              sections: [
                {
                  productItems: [
                    {
                      product_retailer_id: '1',
                    },
                  ],
                  title: 'Título da sessão',
                },
              ],
            }, action_name: 'SendCatalogWhatsApp'
          }, 1, 1, {
            label: 'Catátologo',
            icon: 'storefront'
          }, null, {}, {}, false);
          break;
        case 'transfer_omni':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', action_id: '', wait_finish: true, department: '', back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'TransferOmni' }, 1, 1, {
            label: 'Transferir Omni',
            icon: 'sync_alt',
            background: '#fcb6c0',
          }, null, {}, {}, false);
          break;
        case 'rcs_card':
          editor.addNode(data.x, data.y, data.name,
            {
              comparator: '', text: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false,
              type: 'card',
              body: {
                card: {
                  title: 'Título',
                  text: 'Texto',
                  media: {
                    url: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
                  },
                  buttons: [],
                }
              }, action_name: 'SendRCSMessage'
            }
            , 1, 1, {
            label: 'Cartão',
            icon: 'pages',
            background: '#a8e2ff',
          }, null, {}, {}, false);
          break;
        case 'rcs_carousel':
          editor.addNode(data.x, data.y, data.name,
            {
              comparator: '', text: '', key: '', action_id: '', back_node_id: '', back_id: '', back_name: '', first: false,
              type: 'carousel',
              body: {
                carousel: {
                  width: 'medium',
                  cards: [
                    {
                      title: 'Título',
                      text: 'Texto',
                      media: {
                        url: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
                      },
                      buttons: [],
                    },
                    {
                      title: 'Título',
                      text: 'Texto',
                      media: {
                        url: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
                      },
                      buttons: [],
                    },
                  ],
                },
              }, action_name: 'SendRCSMessage'
            }
            , 1, 1, {
            label: 'Carrossel',
            icon: 'view_carousel',
            background: '#a8e2ff',
          }, null, {}, {}, false);
          break;
        case 'delay':
          editor.addNode(data.x, data.y, data.name, { comparator: '', text: '', key: '', action_id: '', wait_finish: true, seconds: 0, back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'DelayFlow' }, 1, 1, {
            label: 'Delay',
            icon: 'schedule',
            background: '#83f7a3',
          }, null, {}, {}, false);
          break;
        case 'deal':
          editor.addNode(data.x, data.y, data.name, { comparator: '', title: '', stage: '', priority: '', description: '', key: '', action_id: '', wait_finish: true, seconds: 0, back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'SendDeal' }, 1, 1, {
            label: 'Deal',
            icon: 'filter_alt',
            background: '#b0d6ff',
          }, null, {}, {}, false);
          break;
        case 'yup_ai':
          editor.addNode(data.x, data.y, data.name, { failed_class_name: '', url: '', failed_action_node_id: '', failed_action_id: '', comparator: '', actions: [], offers: [], agent_type: '', apiKey: '', company: '', paper: '', key: '', action_id: '', wait_finish: true, objective: '', time_out: 0, back_node_id: '', back_id: '', back_name: '', restrictions: '', tone_of_voice: '', first: false, action_name: 'YupAi' }, 1, 2, {
            label: 'YupAI',
            color: '#000',
            icon: '/assets/img/channels/ai.svg',
            isSource: true,
            background: '#fff',
          }, null, {}, {}, false);
          break;
        case 'opt_out':
          editor.addNode(data.x, data.y, data.name, {  channel: '', identification_account: '', comparator: '', key: '', action_id: '', wait_finish: true, back_node_id: '', back_id: '', back_name: '', first: false, action_name: 'OptOutFlow' }, 1, 1, {
            label: 'OptOut',
            icon: 'person_off',
            color: '#fff',
            background: '#fc0356',
          }, null, {}, {}, false);
          break;
        default:
          break;
      }
}

export { genNodeType }